(function () {
  'use strict';

  function initReveal(section) {
    if (!section.classList.contains('zpb--reveal')) return;

    var targets = section.querySelectorAll('[data-zpb-line]');
    if (!targets.length) return;

    if (!('IntersectionObserver' in window)) {
      targets.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    targets.forEach(function (el) {
      observer.observe(el);
    });
  }

  function initAnchorScroll(section) {
    var boton = section.querySelector('.zpb__boton--principal');
    if (!boton) return;

    boton.addEventListener('click', function (event) {
      var href = boton.getAttribute('href') || '';
      if (href.charAt(0) !== '#' || href.length < 2) return;

      var target = document.getElementById(href.slice(1));
      if (!target) return;

      event.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initSection(section) {
    initReveal(section);
    initAnchorScroll(section);
  }

  function initAll() {
    document.querySelectorAll('[data-zpb]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('[data-zpb]');
    if (section) initSection(section);
  });
})();